<template>
   <input
      type="text"
      class="form-control"
      :value="formattedValue"
      @input="updateValue($event.target.value)"
      @focus="isFocused = true"
      @blur="isFocused = false"
      @keydown="preventNonNumericAndHandleDecimal"
      step="0.01"
      v-bind="$attrs"
   />
</template>

<script>
export default {
   props:['value'],
   data() {
      return {
         isFocused: false,
      };
   },
   computed: {
      formattedValue() {
         if (this.isFocused) {
            // When focused, show the raw number without commas for easy editing
            return Math.round(this.value);
         }
         // Otherwise, format the number with commas for display
         const numberValue = parseFloat(this.value);
         return isNaN(numberValue) ? '' : numberValue.toLocaleString('en-US');
      },
   },
   methods: {
      preventNonNumericAndHandleDecimal(event) {
         const key = event.key;
         const inputValue = event.target.value; // Get current value of the input
         
         // Allowed common control keys: Backspace, Tab, Enter, Delete, Left/Right arrow keys
         // Also allow for copy/paste/cut/select all (Cmd for Mac, Ctrl for Windows)
         const allowedControlKeys = [
         'Backspace', 'Tab', 'Enter', 'Delete', 'ArrowLeft', 'ArrowRight'
         ];

         // Check if it's a control key (Ctrl/Cmd, Alt, Shift)
         const isModifierKey = event.metaKey || event.ctrlKey || event.altKey;

         // Allow if it's an allowed common control key
         if (allowedControlKeys.includes(key)) return;

         // Allow common Ctrl/Cmd combinations for copy/paste/cut/select all
         if (isModifierKey && ['a', 'c', 'v', 'x'].includes(key.toLowerCase())) return;

         // 1. Allow numbers (0-9)
         if (key >= '0' && key <= '9' && !isModifierKey) return; // Allow the digit

         // 2. Allow a single decimal point '.'
         if (key === '.') {
            // Prevent if a decimal point already exists in the input value
            if (inputValue.includes('.')) {
               event.preventDefault(); // Stop the key press
               return;
            }
            return; // Allow the first decimal point
         }
         
         // If none of the above conditions are met, prevent the default action (typing the character)
         event.preventDefault();
      },
      updateValue(newValue) {
         // Remove any non-numeric characters (except for the decimal point)
         const cleanedValue = newValue.replace(/[^0-9.]/g, '');
         // Emit the cleaned number back to the parent component
         this.$emit('input', cleanedValue);
      },
   },
};
</script>